import { ref, watch } from 'vue';
import PostSaleCasesAPI from 'dashboard/api/postSaleCases';

export function usePostSaleRegistryStatus({ caseData }) {
  const error = ref(null);
  const loading = ref(false);
  const result = ref(null);
  let requestSequence = 0;

  const clear = () => {
    requestSequence += 1;
    error.value = null;
    loading.value = false;
    result.value = null;
  };

  const load = async value => {
    if (!value?.id || value.status !== 'registro') {
      clear();
      return null;
    }

    requestSequence += 1;
    const sequence = requestSequence;
    error.value = null;
    loading.value = true;
    result.value = null;

    try {
      const response = await PostSaleCasesAPI.registryStatus(value.id);
      if (sequence !== requestSequence) return null;

      result.value = response.data;
      return result.value;
    } catch (requestError) {
      if (sequence !== requestSequence) return null;

      error.value = requestError;
      result.value = { state: 'unavailable', integration: 'configured' };
      return result.value;
    } finally {
      if (sequence === requestSequence) loading.value = false;
    }
  };

  watch(
    () => [caseData.value?.id, caseData.value?.status],
    () => load(caseData.value),
    { immediate: true }
  );

  return { clear, error, load, loading, result };
}
